import { DomService } from '../dom';

export const DateService = {
  dateTranslationKeyDefaults: {
    dateDay: 'D',
    dateMonth: 'MMMM',
    dateYear: 'YYYY',
    dateNumeric: 'M/D/YYYY',
    dateFull: 'MMMM DD, YYYY',
    dateEvents: 'MMMM DD, YYYY [at]',
    fallback: 'MMMM DD, YYYY',
  },
  formatDate(date: string | Date, options?): string {
    const o = options || { day: 'numeric', year: 'numeric', month: 'long' };
    const { locale } = DomService.getGlobalConfig();
    const parsedDate = typeof date !== 'string' ? date : this.getParsedDate(date);
    const parsedLocale = locale === 'default' || !locale ? undefined : locale;

    return new Intl.DateTimeFormat(parsedLocale, o).format(parsedDate);
  },

  getDateTimeValue(date: string): string {
    const d: Date = this.getParsedDate(date);
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(
      2,
      '0',
    )}-${String(d.getDate()).padStart(2, '0')}`;
  },

  getParsedDate(date: string): Date {
    const unixDate = date?.includes('-')
      ? date?.replace(/\s+/g, 'T')
      : parseInt(date?.replace(/\s+/g, 'T'), 10);
    return new Date(unixDate);
  },
};
